export default "__VITE_ASSET__DttYRDbE__"